var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thmbDown",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 88.9",
    style: {
      enableBackground: "new 0 0 100 88.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "col-stroke_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "col-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.9,39.6c1.3-1.6,2.2-3.7,2.2-6.1c0-3.7-2.1-6.9-5.2-8.4c0.6-1.2,0.9-2.5,0.9-3.9c0-3.3-1.8-6.3-4.5-7.8 c0.6-1.2,1-2.6,1-4.1c0-5-4.1-9.1-9.1-9.1H49c-3.4,0-6.8,0.8-10.4,1.7C34.2,3,29.1,4.2,23.1,4.2v-1c0-1.8-1.4-3.2-3.2-3.2H3.2 C1.4,0,0,1.4,0,3.2v47.5c0,1.8,1.4,3.2,3.2,3.2h16.7c1.8,0,3.2-1.4,3.2-3.2v-2.5C43.5,57.3,45.6,70.1,47,78.6 c0.7,4.5,1.4,8.4,5,9.7c2.7,1,5.4,0.6,7.9-1.1c4.3-3,6.6-9.3,6.6-13.7V73c0-4.5,0-10.7-2.7-16.3H90c5.5,0,10-4.5,10-10 C100,43.9,98.8,41.4,96.9,39.6z M16.2,10.5c0,2.1-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9S16.2,8.4,16.2,10.5z  M92.9,33.5c0,1.8-1.3,3.2-3,3.2s-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1l0,0l0,0c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8H58 c-1.2,0-2.4,0.7-2.8,1.9c-0.5,1.1-0.3,2.5,0.6,3.3c4.6,4.8,4.6,12,4.5,17.3v0.5c0,3.2-1.8,7.2-3.9,8.7c-0.9,0.6-1.5,0.6-2.1,0.4 c-0.5-0.7-0.9-3.1-1.2-5c-1.5-8.9-4.2-25.5-29.8-36c-0.1,0-0.2,0-0.2-0.1V10.4c6.7,0,12.2-1.3,16.9-2.5c3.4-0.8,6.4-1.6,9-1.6 h33.2c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h3.5c1.6,0,2.9,1.3,2.9,2.9 s-1.3,2.9-2.9,2.9c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h4C91.5,30.2,92.9,31.7,92.9,33.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingDown);
export default __webpack_public_path__ + "static/media/rating-down.fb70eb98.svg";
export { ForwardRef as ReactComponent };